export default {
  TAB_FOCUS: 'TAB_FOCUS',
  TAB_BLUR: 'TAB_BLUR',
  RENDER_MODAL: 'RENDER_MODAL',
  MODAL_MINIMIZE: 'MODAL_MINIMIZE',
  MODAL_MAXIMIZE: 'MODAL_MAXIMIZE',
  CHECKIN_POSTED: 'CHECKIN_POSTED',
  INITIATIVE_UPDATED: 'INITIATIVE_UPDATED',
  INITIATIVE_CUSTOM_FIELD_VALUE_UPDATED: 'INITIATIVE_CUSTOM_FIELD_VALUE_UPDATED',
  INITIATIVE_CUSTOM_FIELD_FORMULA_UPDATED: 'INITIATIVE_CUSTOM_FIELD_FORMULA_UPDATED',
  INITIATIVES_DELETED: 'INITIATIVES_DELETED',
  INITIATIVES_MOVED: 'INITIATIVES_MOVED',
  TASKS_MOVED: 'TASKS_MOVED',
  IDEA_UPDATED: 'IDEA_UPDATED',
  TEAM_ARCHIVED_UNARCHIVED: 'TEAM_ARCHIVED_UNARCHIVED',
  COMMENT_ADDED: 'COMMENT_ADDED',
  COMMENT_EDITED: 'COMMENT_EDITED',
  COMMENT_DELETED: 'COMMENT_DELETED',
  VISIT_HISTORY_UPDATED: 'VISIT_HISTORY_UPDATED',
  KR_COMMENT_ADDED: 'KR_COMMENT_ADDED',
  KR_CLOSED: 'KR_CLOSED',
  GOAL_CLOSED: 'GOAL_CLOSED',
  SUBSCRIBED: 'SUBSCRIBED',
  UNSUBSCRIBED: 'UNSUBSCRIBED',
  USER_LIST_CHANGED: 'USER_LIST_CHANGED',
  OPEN_SPOTLIGHT_SEARCH: 'OPEN_SPOTLIGHT_SEARCH',
  PARENT_GOAL_ALIGNMENT_CHANGED: 'PARENT_GOAL_ALIGNMENT_CHANGED',
  SHOW_KEYMAP_MODAL: 'SHOW_KEYMAP_MODAL',
  CHILD_GOAL_CREATED: 'CHILD_GOAL_CREATED',
  SUBMIT_FORM: 'SUBMIT_FORM',
  CONFIRM_DIALOG: 'CONFIRM_DIALOG',
  ADD_INITIATIVE: 'ADD_INITIATIVE',
  SHOW_404: 'SHOW_404',
  BULK_ACTION_DONE: 'BULK_ACTION_DONE'
}
